var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtractProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 73,
    viewBox: "0 0 78 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.7546 72.8209L63.5337 53.8452V23.8363L30.7546 42.8134V72.8209Z",
    fill: "#C9974B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M77.498 28.068V27.025L30.7562 42.8137V43.8553L44.719 47.0437L77.498 28.068Z",
    fill: "#BF8937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.66791 29.9619L30.7578 42.8136V72.8211L8.66791 60.0422V29.9619Z",
    fill: "#AB7835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.7108 57.4395L28.5229 62.5854V68.499L19.7108 63.3663V57.4395Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.9194 37.05L10.9366 41.6149L13.0394 42.814L13.0235 38.2491L14.0742 38.8487L11.9596 34.3552L9.86742 36.4504L10.9194 37.05Z",
    fill: "#471D1D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.6122 35.2378L20.7973 37.0246L20.8633 44.2882L17.6122 42.3492V35.2378Z",
    fill: "#C2BFB4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M20.582 58.9181L20.9424 59.1352V63.1085L20.582 62.8914V58.9181Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M21.3281 59.3533L21.6885 59.5703V63.5423L21.3281 63.3252V59.3533Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M22.0734 59.788L22.4351 60.005V63.9783L22.0734 63.7613V59.788Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M22.8175 60.222L23.1792 60.4391V64.4124L22.8175 64.1953V60.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M23.565 60.6577L23.9253 60.8748V64.8481L23.565 64.631V60.6577Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M24.3096 61.0905L24.6699 61.3075V65.2808L24.3096 65.0638V61.0905Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M25.0544 61.5265L25.416 61.7436V65.7155L25.0544 65.4985V61.5265Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M25.7998 61.9607L26.1602 62.1777V66.1511L25.7998 65.934V61.9607Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M26.5464 62.3944L26.9067 62.6115V66.5848L26.5464 66.3677V62.3944Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M27.2912 62.8306L27.6528 63.0476V67.0209L27.2912 66.8039V62.8306Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M0.499523 20.8029L8.66622 31.0048L41.4453 12.0291L0.499523 19.7612V20.8029Z",
    fill: "#AB7835"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M0.499523 19.7605L8.66622 29.9624L41.4453 10.9854L33.2786 0.783447L0.499523 19.7605Z",
    fill: "#FFDC91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M77.498 27.0257L63.5353 23.8373L30.7562 42.8143L44.719 46.0028L77.498 27.0257Z",
    fill: "#D6AC54"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M41.4458 10.985L63.5356 23.8367L30.7566 42.8137L8.66669 29.9621L41.4458 10.985Z",
    fill: "#EBC26C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M11.2965 29.9637L23.6911 37.177L30.753 41.28L41.4449 35.0991L47.9524 31.3269L60.9014 23.8356L41.4449 12.5193L11.2965 29.9637Z",
    fill: "#AB7835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M11.2989 29.9637L23.6935 37.177L30.7554 41.28L41.4473 35.0991V12.5193L11.2989 29.9637Z",
    fill: "#C9974B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M23.6938 34.4248V37.1777L30.7557 41.2807L41.4476 35.0998L47.9551 31.3276L41.4476 27.5555L38.5172 25.8481L23.6938 34.4248Z",
    fill: "#B39876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M44.7202 46.002V47.0437L30.7575 43.8552V42.8136L44.7202 46.002Z",
    fill: "#AB7835"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M28.2584 14.5238L28.2957 31.1114L35.9309 35.4777L41.5206 32.1606L41.5187 16.7878L39.7131 21.0753L45.3008 17.7562L37.6381 1.42297L32.0484 4.74008L24.4388 12.3387L28.2584 14.5238Z",
    fill: "#94000A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M28.2582 14.5193L28.2956 31.1069L35.9307 35.4732L35.8933 18.8876L39.7129 21.0708L32.0482 4.7356L24.4386 12.3362L28.2582 14.5193Z",
    fill: "#F91F43"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtractProduct);
export default __webpack_public_path__ + "static/media/extractProduct.86a3a5f3bc50c41c55405b5b7db0e26c.svg";
export { ForwardRef as ReactComponent };